module.exports = __webpack_public_path__ + "static/unfuddle-7b8cf585c3367728596dfbc7d137cd52.svg";